export const interactLetter = 'x'
export const KEYBOARD_HELP_DURATION = 10000
